import { render, staticRenderFns } from "./ConnectStateroomItem.vue?vue&type=template&id=62c70fb0&scoped=true"
import script from "./ConnectStateroomItem.vue?vue&type=script&lang=js"
export * from "./ConnectStateroomItem.vue?vue&type=script&lang=js"
import style0 from "./ConnectStateroomItem.vue?vue&type=style&index=0&id=62c70fb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c70fb0",
  null
  
)

export default component.exports